export const supportEmail = 'support@letterdesk.app';
export const supportMailTo = `mailto:${supportEmail}`;
